import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = {
    key: 0,
    class: "form__legend"
};
import { computed, onUnmounted, reactive, watch } from "vue";
import { get, set } from "lodash";
import { validateField } from "./FormValidator";
import log from "../../services/Logger";
import FormGroup from "./FormGroup.vue";
import { applyDefaults, defaultValue, fieldPath } from "./fieldControls";
import { applyFieldValidation, clearFieldValidation } from "./formValidation";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormFields',
    props: {
        form: {},
        fields: {},
        data: {},
        validation: {},
        mode: {},
        legend: {},
        submitted: { type: Boolean },
        disabled: { type: Boolean },
        fieldPrefix: {}
    },
    emits: [
        'fieldChange',
        'change',
        'bulkSelectToggle',
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Callers may pass plain objects. `reactive` returns a proxy of the very same
        //   object, so writes still end up in the caller's data and validation.
        const model = computed(() => props.data ? reactive(props.data) : props.data);
        const validationModel = computed(() => reactive(props.validation));
        // the validation keys this field set owns
        const keys = computed(() => (props.fields || []).map(field => fieldPath(props.fieldPrefix, field.name)));
        // Initializes empty nested forms, sections and required booleans before
        //   they are rendered, and again whenever such a field is emptied.
        watch(() => (props.fields || []).some(field => defaultValue(field) !== undefined && isEmpty(get(model.value, field.name))), missingDefaults => {
            if (missingDefaults) {
                applyDefaults(model.value, props.fields || []);
            }
        }, { immediate: true });
        // Validates this field set whenever one of its values or field options changes.
        //   Only what `validateField` reads is tracked, so editing a field re-validates
        //   its own field set only, not its parents nor its siblings. The validation
        //   object itself is not tracked: server-side errors passed in stay visible
        //   until the user edits the field set.
        watch(validateFields, results => applyFieldValidation(validationModel.value, keys.value, results), { immediate: true });
        watch(keys, (newKeys, oldKeys) => clearFieldValidation(validationModel.value, oldKeys.filter(key => newKeys.indexOf(key) === -1)));
        onUnmounted(() => clearFieldValidation(validationModel.value, keys.value));
        function validateFields() {
            const data = model.value ?? {};
            return (props.fields || []).map(field => validateField(field, data));
        }
        function fieldData(field) {
            return get(model.value, field.name);
        }
        function isEmpty(value) {
            return value === null || value === undefined;
        }
        function onChange(field, data) {
            if (model.value) {
                set(model.value, field.name, data);
            }
            // validate right away, so change listeners see the current validation
            applyFieldValidation(validationModel.value, keys.value, validateFields());
            log('FormFields@change', field.name, data);
            emit('fieldChange', field.name, data);
            emit('change', props.data);
        }
        function onBulkSelectToggle(fieldPath) {
            emit('bulkSelectToggle', fieldPath);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("fieldset", {
                class: "form__field-set",
                disabled: __props.disabled
            }, [
                (__props.legend)
                    ? (_openBlock(), _createElementBlock("legend", _hoisted_2, _toDisplayString(__props.legend), 1))
                    : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
                    return (_openBlock(), _createBlock(FormGroup, {
                        key: field.name,
                        form: __props.form,
                        field: field,
                        "field-prefix": __props.fieldPrefix ?? '',
                        data: fieldData(field),
                        validation: validationModel.value,
                        submitted: __props.submitted,
                        mode: __props.mode,
                        onChange: ($event) => (onChange(field, $event)),
                        onBulkSelectToggle: onBulkSelectToggle
                    }, null, 8, ["form", "field", "field-prefix", "data", "validation", "submitted", "mode", "onChange"]));
                }), 128))
            ], 8, _hoisted_1));
        };
    }
});
